import React, {useContext, useEffect, useRef, useState} from 'react';
import { Avatar, TextField, InputAdornment, IconButton, Typography, List, ListItem, ListItemText, Paper } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {convertHexToRgba, getVPCService, isMobile, parseJSON, publicChatData} from "../App/utils.js";
import {ImageToText} from "../InputTools/ImageToText.js";
import {UploadFile} from "../InputTools/UploadFile.js";
import {backgroundColor} from "../App/theme.js";
import {DocToText} from "../InputTools/DocToText.js";
import {onSpeechToTextClick, SpeechToText} from "../InputTools/speechToText.js";
import {AlertContext} from "../App/App.js";
import { ImageEditor } from '../InputTools/ImageEditor.js';
import {isSpeechToText} from "../InputTools/utils";
import {getKBImage} from "../KB/KBImage";
import {
    AddReactionOutlined,
    ArrowBackIos,
    ArrowForwardIos,
    Bookmarks,
    PeopleAlt,
    DeleteOutline,
    ZoomOutMap,
    ZoomInMap,
    PictureAsPdf
} from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import {pageLoadedIn, RAW_FILES_URL} from "../utils";
import {useInputValue} from "../Context/ChatInputProvider";
import {createSendMessage} from "./sendMessage";
import {wsSend} from "../API/Websocket";
import {WS_MESSAGE} from "../App/constants";
import Dialog from "@mui/material/Dialog";
import {EmojiPicker} from "./EmojiPicker";
import {
    createCommand,
    getMessageToTheUser,
    parseKBCommands,
    parseInputLabels,
    SuggestionsContainer,
    useOutsideClick
} from "./ChatInputHelpers";
import {ChatModels} from "../constants";
import {VisionImageUpload} from "../InputTools/VisionImageUpload";
import SearchIcon from "@mui/icons-material/Search";
import {TypingLabel} from "../Components/TypingLabel";
import {isKBImageEditor} from "./Chat";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {deleteRawKBFile} from "../API/KB/Files";

let lastTyping = null;
export const ChatInput = ({
                              isStreaming,
                              onImageToTextResponse,
                              setBlockingLoading,
                              KB,
                              setIsRecording,
                              isRecordingRef,
                              setIsTalking,
                              setMicEnabled,
                              micEnabled,
                              isRecording,
                              isTalking,
                              micLoading,
                              setMicLoading,
                              messages,
                              addressToAI,
                              setAddressToAI,
                              setMessages,
                              RequestChatAPI,
                              navigateToChat,
                              setKBChats,
                              itemsAreLoading,
                              chatId,
                              isContextItemsOpen,
                              setIsContextItemsOpen,
                              renderSettings,
                              ChatData,
                              sendButtonRippleRef,
                              uploadedImages,
                              setUploadedImages
}) => {

    const { inputValue, setInputValue } = useInputValue();
    const [expandedImageIndex, setExpandedImageIndex] = useState(null);

    const sendMessage = createSendMessage({
        isStreaming,
        setMessages,
        messages,
        RequestChatAPI,
        navigateToChat,
        setKBChats,
        itemsAreLoading,
        chatId,
        inputValue,
        setInputValue,
        uploadedImages,
        setUploadedImages,
        renderSettings
    });

    const input = useRef(null);
    const labelsSuggestionsRef = useRef(null);
    const iconButtonRef = useRef(null);
    const [activeEmojiMenuInput, setActiveEmojiMenuInput] = useState(null);
    const [commands, setCommands] = useState(null);
    const [inputLabels, setInputLabels] = useState(null);
    const [labelsSuggestions, setLabelsSuggestions] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const inputContainerRef = useRef(null);
    const toolsRef = useRef(null);
    const [hasFocused, setHasFocused] = useState(false);
    const [placeholder, setPlaceholder] = useState('');
    const [menuOpen, setMenuOpen] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(false);

    // focus the input after response is done
    useEffect(() => {
        if (isKBImageEditor(KB)) return;
        if (!isStreaming && input?.current && pageLoadedIn() > 1000 && !renderSettings?.disableAutoFocusChatInput) {
            setTimeout(() => input?.current?.focus(), 100)
        }
    }, [isStreaming]);

    useEffect(() => {
        // Clear images whenever chatId changes (new chat created)
        if (chatId === null || chatId === undefined) {
            setUploadedImages([]);
        }
    }, [chatId, setUploadedImages]);

    useEffect(() => {
        if (inputValue && labelsSuggestions?.length) {
            setLabelsSuggestions([])
        }
    }, [inputValue]);


    useEffect(() => {
        if (!KB?.kbTitle) return; // still loading

        if (!localStorage.getItem('firstLoad')) {
            setIsFirstLoad(true)
            localStorage.setItem('firstLoad', 'true');
        }
    }, [KB]);

    useOutsideClick(toolsRef, () => {
        setMenuOpen(false);
    });

    useOutsideClick(inputContainerRef, () => {
        setSuggestions([]);
    });

    useEffect(() => {
        if (KB?.kbInstructions && KB?.kbInstructions.length > 0 && parseKBCommands(KB.kbInstructions)?.length) {
            setPlaceholder(isMobile ? 'Type / for commands' : 'Type / to check all commands');
        } else {
            setPlaceholder('');
        }

        setCommands(parseKBCommands(KB.kbInstructions))
        setInputLabels(parseInputLabels(KB.kbInstructions))
    }, [KB]);

    useEffect(() => {
        if (inputValue && commands) {
            const matchedCommands = commands.filter(cmd => {
                const showAll = (inputValue === '/');
                const inputText = inputValue.toLowerCase().replace('/', '');
                const command = cmd.command.toLowerCase()
                return (command.includes(inputText) && inputText?.length >= 2) || showAll
            });
            setSuggestions(matchedCommands);
        } else {
            setLabelsSuggestions([]);
            setSuggestions([]);
        }
    }, [inputValue, commands]);

    const handleFocus = () => {
        // if (inputLabels && !hasFocused) {
        //     setLabelsSuggestions(inputLabels)
        //     labelsSuggestionsRef?.current?.pulsate()
        //     setHasFocused(true);
        // }
    };

    const handleSuggestionClick = (suggestion) => {
        setInputValue(createCommand(suggestion));
        setSuggestions([]);
        setTimeout(() => {
            if (input.current) {
                const position = inputValue.length + suggestion.command.length + 3; // Adjust based on the command length
                input.current.focus();
                input.current.setSelectionRange(position, position);
            }
        }, 100);
    };

    const handleLabelSuggestionClick = (suggestion) => {
        setLabelsSuggestions([]);
        if (renderSettings?.inputLabelsQuickSend) {
            sendMessage({injectedMessage: suggestion.InputValue})
        } else {
            setInputValue(suggestion.InputValue);
            setTimeout(() => sendButtonRippleRef?.current?.pulsate(), 50)
        }
    };

    const addReaction = ({native}) => {
        setTimeout(() => input?.current?.focus(), 100)
        setInputValue(prev => prev + ' ' + native)
        setActiveEmojiMenuInput(false);
    };

    const EndAdornment = () => (
        <InputAdornment position="end">
            {/* we could show this, but only if context items exist */}
            {/*{inputValue && <IconButton onClick={(e) => setIsContextItemsOpen(prev => !prev)} aria-label="find context items">*/}
            {/*    <SearchIcon />*/}
            {/*</IconButton> }*/}

            {/*@Todo Valfix*/}
            {!renderSettings?.disableEmojiButton && !publicChatData && <IconButton onClick={(e) => setActiveEmojiMenuInput(true)} aria-label="add reaction">
                <AddReactionOutlined />
            </IconButton>}
        </InputAdornment>
    );

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && (!isMobile || publicChatData)) {
            e.preventDefault();
            e.stopPropagation();
            sendMessage({toChatOnly: !addressToAI && !inputValue?.startsWith('/')}).then();
        }
    };

    let inputOpacity = inputValue.length < 3 ? 0 : Math.min(0.75, parseInt(inputValue.length) / 50);
    const commonProps = {setBlockingLoading, renderSettings}

    const appendToInput = (moreInput) => setInputValue((prevInput) => prevInput ? prevInput + '\n' + moreInput : moreInput)

    // Handle image upload to shared state
    const handleImageUpload = (url) => {
        const newUploadedImages = [...uploadedImages, url];
        setUploadedImages(newUploadedImages);
        // Focus input after image upload
        setTimeout(() => input?.current?.focus(), 100);
    }

    const {setSystemAlert} = useContext(AlertContext);

    const speechToTextToolId = KB?.inputTools?.find( toolName => isSpeechToText(toolName))

    const speechToTextProps = {
        isRecording,
        setIsRecording,
        isRecordingRef,
        setIsTalking,
        setSystemAlert,
        setMicEnabled,
        setMicLoading,
        sendMessage,
        setInputValue,
        speechToTextToolId,
        KB,
        addressToAI,
        setBlockingLoading
    };
    const lastMsg = !isStreaming && messages[messages.length - 1];

    // Toggle function for addressing AI or chat
    const toggleAddressToAI = () => {
        setAddressToAI(!addressToAI);
    };


    const avatarStyle = {width: '28px', height: '28px', borderRadius: '50%'};

    const isMultichat = KB?.sharedWithUsers?.length;
    let toChatIcon;
    if (isMultichat) {
        toChatIcon = KB?.sharedWithUsers?.length === 1
            ? <Avatar alt={'User'} src={`${RAW_FILES_URL}/user-image/${KB?.sharedWithUsers?.[0]}.png`} style={avatarStyle} />
            : <PeopleAlt />
    }

    const chatIcon = ChatData?.chatIcon;


    const selectedAvatar = (
        <div style={{ width: 25, height: 25, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {(addressToAI || inputValue?.startsWith('/'))
                ? (chatIcon ? <div style={{ fontSize: 20 }}>{chatIcon}</div> : <Avatar alt="AI" src={getKBImage(KB?.publishedKbId || KB?.kbId)} style={avatarStyle} />)
                : toChatIcon}
        </div>
    );


    const divStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '5px',
        marginBottom: '0px',
        marginRight: '-0px',
        marginLeft: '-10px'
    };

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {},
        [`& .${tooltipClasses.tooltip}`]: {},
    }));

    const hasVision = ChatModels[KB?.model]?.vision?.type === 'image_url';
    let toolsCount = 0;
    if (isMultichat && !renderSettings?.disableMultichat) toolsCount++;
    if (hasVision) toolsCount++;
    if (KB?.inputTools?.length) toolsCount += KB?.inputTools?.length;

    // Function to extract image URLs from inputValue
    const extractContentWithURLs = (inputValue) => {
        if (!inputValue?.includes('{"type":"image_url","image_url":{"url":"')) return;

        const lines = inputValue.split('\n');
        const content = [];

        lines.forEach(line => {
            try {
                const json = JSON.parse(line);
                if (json && json.image_url && json.image_url.url) {
                    content.push({ type: 'image', url: json.image_url.url });
                }
            } catch (e) {
                // Not a valid JSON, treat it as text
                content.push({ type: 'text', text: line });
            }
        });

        return content;
    };

    // We're not using extractContentWithURLs anymore since we're storing images separately
    // Use uploadedImages state instead
    if (uploadedImages.length > 0) inputOpacity = 1;

    const notEnoughInputSpace = uploadedImages.length > 0 && isMobile;

    // const messageToTheUser = getMessageToTheUser(KB)

    const AIName = 'AI'
    return (
        <ClickAwayListener
            onClickAway={(event) => {
                setLabelsSuggestions([])
            }}
        >
        <div ref={inputContainerRef}>
            <Dialog
                PaperProps={{
                    style: {
                        borderRadius: 10
                    },
                }}
                open={!!activeEmojiMenuInput}
                onClose={() => {
                    setActiveEmojiMenuInput(null)
                }}
                aria-labelledby="emoji-picker-dialog"
                aria-describedby="emoji-picker-dialog-description"
            >
                <EmojiPicker onEmojiSelect={addReaction} />
            </Dialog>
            <TextField
                placeholder={!hasFocused && placeholder || ''}
                id="input-with-icon"
                inputRef={input}
                onFocus={handleFocus}
                style={{
                    flex: 1,
                    minHeight: '53px',
                    maxHeight: '500px',
                    overflowY: 'auto',
                    paddingRight: '10px',
                    marginBottom: (isMobile ? -10 : 0),
                    left: 0,
                    height: 'auto',
                    backgroundColor: convertHexToRgba(backgroundColor, inputOpacity),
                }}
                autoComplete="off"
                fullWidth={true}
                multiline={true}
                disabled={isStreaming}
                value={inputValue}
                onKeyPress={handleKeyPress}
                onChange={(e) => {
                    setInputValue(e.target.value)
                    if (lastTyping > +new Date() - 10000) return;
                    lastTyping = +new Date();
                    const token = localStorage.getItem('kbJWT');
                    wsSend({type: WS_MESSAGE.USER_TYPING, chatId, token});
                }}
                variant="outlined"
                InputProps={{
                    startAdornment: (
                           <InputAdornment position="start" ref={toolsRef}>
                               {!renderSettings?.disableMultichat && (isMultichat || renderSettings?.isMultichat) && (
                                   <BootstrapTooltip
                                       placement="top"
                                       title={(addressToAI || inputValue?.startsWith('/')) ? `Send to ${AIName} for response` : "Send to people only"}
                                   >
                                       <IconButton
                                           ref={iconButtonRef} onClick={toggleAddressToAI} color="primary" component="span">
                                           {isMobile ? (
                                               <div key={'to'} style={{...divStyle, display: 'flex', alignItems: 'center'}}>
                                                   <div style={{display: 'flex', alignItems: 'center', height: '24px'}}>
                                                       {KB?.kbId && selectedAvatar}
                                                   </div>
                                                   <Typography fontSize={8} style={{ marginTop: 5}}>
                                                       {(addressToAI || inputValue?.startsWith('/')) ? 'To AI' : 'To chat'}
                                                   </Typography>
                                               </div>
                                           ) : (
                                               selectedAvatar
                                           )}
                                       </IconButton>
                                   </BootstrapTooltip>
                               )}

                               {ChatModels[KB?.model]?.vision?.type === 'image_url'
                                   && <VisionImageUpload {...commonProps} kbId={KB?.kbId}
                                                         onSuccess={(url) => {
                                                             // Add image to uploadedImages state instead of input text
                                                             handleImageUpload(url);
                                                         }} />}

                               {/* Tools behind Menu */}
                               {(menuOpen || !isMobile || toolsCount < 3) ?
                                <>

                                {KB?.inputTools?.includes("docToText") &&
                                    <DocToText {...commonProps}  onSuccess={appendToInput} KB={KB} />}

                                {KB?.inputTools?.includes("imageToText") &&
                                    <ImageToText {...commonProps} textOnly={true} onImageToTextResponse={onImageToTextResponse} KB={KB} />}

                                {KB?.inputTools?.includes("imageToTextAdvanced") &&
                                    <ImageToText {...commonProps} onImageToTextResponse={onImageToTextResponse} KB={KB} />}

                                {KB?.inputTools?.includes("uploadFile") &&
                                    <UploadFile {...commonProps} kbId={KB?.kbId}
                                                onSuccess={(msg) => {
                                                    msg = msg.replace('https://openkbs-files-raw.s3.amazonaws.com/', (getVPCService('file') || 'https://file.openkbs.com/'))
                                                    appendToInput("File uploaded:\n" + msg)
                                                }} />}

                                {KB?.inputTools?.find( o => parseJSON(o)?.type === 'imageEditor') &&
                                    <ImageEditor {...commonProps} kbId={KB?.kbId}
                                                 onSuccess={(msg) => {
                                                     sendMessage({injectedMessage: msg, appendOnly: true})
                                                 }} />}

                                {speechToTextToolId &&
                                    <SpeechToText {...{micEnabled, isRecording, isTalking, micLoading, ...commonProps}}
                                                  onClick={()=> onSpeechToTextClick(speechToTextProps)}
                                    />}

                                {/*<ArrowBackIos style={{cursor: 'pointer'}} onClick={() => setMenuOpen(prev => !prev)} />*/}
                            </>
                        :
                            <>
                                <ArrowForwardIos style={{cursor: 'pointer'}} onClick={() => setMenuOpen(prev => !prev)} />
                            </>}

                           {/* Render uploaded images */}
                           {uploadedImages.length > 0 && (
                               <div style={{
                                  display: 'flex',
                                  gap: '5px',
                                  marginLeft: '5px'
                               }}>
                                   {uploadedImages.map((url, index) => (
                                       <div key={index} style={{ position: 'relative', marginRight: '5px' }}>
                                           {url?.toLowerCase?.()?.endsWith?.('pdf')
                                               ? <PictureAsPdf />
                                               :
                                           <img
                                               src={url}
                                               alt={`Uploaded ${index}`}
                                               style={{
                                                   width: expandedImageIndex === index ? '200px' : '40px',
                                                   height: expandedImageIndex === index ? '200px' : '40px',
                                                   objectFit: 'cover',
                                                   borderRadius: '4px',
                                                   cursor: 'pointer',
                                                   transition: 'all 0.2s ease'
                                               }}
                                               onClick={() => {
                                                  // If image is already expanded, collapse it
                                                  if (expandedImageIndex === index) {
                                                    setExpandedImageIndex(null);

                                                    // Remove extra newlines when collapsing
                                                    setInputValue(prev => {
                                                      // Remove up to 5 trailing newlines
                                                      return prev.replace(/\n{1,8}$/, '');
                                                    });
                                                  } else {
                                                    // Expand the image
                                                    setExpandedImageIndex(index);

                                                    // Add newlines when expanding
                                                    setInputValue(prev => {
                                                      // Count existing trailing newlines
                                                      const match = prev.match(/(\n*)$/);
                                                      const trailingNewlines = match ? match[1].length : 0;

                                                      // Add enough newlines to get to 8
                                                      if (trailingNewlines < 8) {
                                                        return prev + '\n'.repeat(8 - trailingNewlines);
                                                      }
                                                      return prev;
                                                    });
                                                  }
                                                }}
                                           />}
                                           <div
                                               style={{
                                                   position: 'absolute',
                                                   top: '-5px',
                                                   right: '-5px',
                                                   cursor: 'pointer',
                                                   backgroundColor: 'white',
                                                   borderRadius: '50%',
                                                   width: '16px',
                                                   height: '16px',
                                                   display: 'flex',
                                                   alignItems: 'center',
                                                   justifyContent: 'center'
                                               }}
                                               onClick={() => {
                                                   const newImages = uploadedImages.filter((_, i) => i !== index);
                                                   const filename = uploadedImages?.[index]?.split?.('/')?.pop?.();
                                                   deleteRawKBFile(filename, 'files')
                                                   setUploadedImages(newImages);
                                               }}
                                           >
                                               <DeleteOutline style={{ fontSize: '12px' }} />
                                           </div>
                                       </div>
                                   ))}
                               </div>
                           )}
                               <div onClick={() => {
                                   input?.current?.focus()
                               }}>
                               {/*{isFirstLoad && KB?.inputTools?.length >= 0 && !hasFocused && messageToTheUser &&*/}
                               {/*    <TypingLabel text={messageToTheUser} speed={20} blinkingCursor={true} />}*/}
                                </div>
                               {inputLabels?.length > 0 &&
                                   <IconButton
                                       disabled={inputValue}
                                       touchRippleRef={labelsSuggestionsRef}
                                       onClick={() => {
                                           setLabelsSuggestions(prev => prev.length ? [] : inputLabels)
                                           setHasFocused(true);
                                       }}
                                   ><Bookmarks style={{color: inputValue ? 'gray' : undefined}} /></IconButton>}
                        </InputAdornment>
                    ),
                    endAdornment: notEnoughInputSpace ? '' : <EndAdornment />
                }}
            />
            {(suggestions?.length > 0 || (labelsSuggestions?.length > 0)) && (

                <SuggestionsContainer>
                    <Paper>
                        <List component="nav" aria-label="suggestions">
                            {suggestions?.length > 0 && suggestions.map((suggestion, index) => (
                                <ListItem button key={"a" + index} onClick={() => handleSuggestionClick(suggestion)}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                {createCommand(suggestion)} - <span style={{ opacity: 0.7 }}>{suggestion.description}</span>
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                            ))}

                            {labelsSuggestions?.length > 0 && labelsSuggestions.map((suggestion, index) => (
                                <ListItem button key={"b" + index} onClick={() => handleLabelSuggestionClick(suggestion)}>
                                    <ListItemText
                                        primary={
                                            <React.Fragment>
                                                {suggestion?.InputLabel}
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </SuggestionsContainer>

            )}
        </div>
        </ClickAwayListener>
    );
};